export interface ApplicationTableData {
    form: string,
    applicant?: string,
    firstSuggestedName: string,
    date: string,
    negotiator?: string,
    status?: string,
    progress?: string,
    sysId?: string, // caseSysId
    caseNumber?: string,
    contactName?: string,
    companyName?: string,
    submittedDate?: string,
    systemId?: string // actual sysId

}

export interface UserData {
    userName: string,
    accessType?: string,
    status?: string,
    email?: string,
    uniqueId?: string,
    firstName?: string,
    lastName?: string,
    companyName?: string,
    orgId?: string
}

export interface DashboardRequest {
    orgId: string,
    status?: string[]
}

export interface AddNewUserRequest {
    firstName: string,
    lastName : string,
    emailAddress : string,
    role : RoleObject[]
}

export interface RoleObject {
    roleName : string
}

export interface UpdateAccessTypeRequest {
    orgId : string,
    currentRole : string,
    newRole : string,
    email : string
}

export interface ApplicationData {
    sysId?: string,
    formType?: string,
    lockedById?: string,
    lastLockedTime?: string,
    firstSuggestedName: string,
    revisionName?: string,
    revisionReason?: string,
    designationForSalt?: string,
    chemName?: string,
    chemNameForEntity?: string,
    chemNameForSalt?: string,
    structFormula?: string,
    structFormulaForEntity?: string,
    structFormulaForSalt?: string,
    molecularFormula?: string,
    molecularFormulaForEntity?: string,
    molecularFormulaForSalt?: string,
    molecularWeight?: string,
    molecularWeightForEntity?: string,
    molecularWeightForSalt?: string,
    isProdDrug?: boolean,
    casRegistryNumber?: number,
    casRegistryForEntity?: number,
    casRegistryForSalt?: number,
    theraClaim?: string,
    uniiNumber?: number,
    uniiNumberSalt?: number,
    codeDesignation?: string,
    codeDesignationForEntity?: string,
    codeDesignationForSalt?: string,
    trademark?: string,
    trivialName?: string,
    manufacturer: string,
    principalTheraUse?: string,
    pharmaAction?: string,
    bindToReceptor?: boolean,
    bindToReceptorExplanation?: string,
    innSubmission?: string,
    innSubmissionNumber?: string,
    innSubmissionExplanation?: string,
    isPolymerPresent?: string,
    semiInterNetwork?: string,
    degreeOfPolymerization?: string,
    monomerFormula?: string,
    chemicalsAttached?: string,
    manufacturingProcess?: string,
    purity?: string,
    waterContent?: string,
    waterContentAtAmbientTemp?: string,
    waterContentMeanValue?: number,
    waterContentMeasurement?: number,
    oxygenPermeability?: string,
    oxygenPermeability35?: string,
    oxygenPermeabilityMeanValue?: number,
    oxygenPermeabilityMeasurement?: number,
    oxygenPermeabilityMethod?: string,
    clinicalTrialDate: string,
    indApplNumber?: string,
    submittedBy?: string,
    submittedByUserObj?: UserData,
    applicant: string,
    applicantEmail: string,
    address?: string,
    phone: string,
    phoneType?: string,
    contactPerson: string,
    pronoun?: string,
    title?: string,
    emailAddress: string,
    date: string,
    negotiator: string,
    caseNumber?: string,
    priorComments?: string,
    caseStatus: string,
    usanUser?: string,
    usanUserName?: string,
    systematicName?: string,
    sequence?: string,
    surfaceModification?: string,
    paymentStatus?: string,
    paymentType?: string,
    paymentDetails?: string,
    cashReceiptNumber?: string,
    paymentReceivedDate?: string,
    finalAdoptedName?: string,
    adoptedOrClosedDate?: string,
    whoExplanation?: string,
    finalAdoptedNameMod?: string,
    fileNumber: string,
    fileNumberModified: string,
    submittedDate?: string,
    contactPersonFirstName?: string,
    contactPersonLastName?: string,
    collaborator1?: string,
    collaborator2?: string,
    previousApplicantName?: string
}

export interface CommentData {
    value: string,
    date: string
}

export interface SupplementalData {
    name: string,
    fileType: string,
    id: string,
    link: string,
    type: string
}

export interface UpdateCaseRequest {
    u_usan_user_sso_id ?: string,
    u_usan_user_firstname ?: string,
    u_usan_user_lastname ?: string,
    u_usan_user_email ?: string,
    u_usan_collaborator_1_sso_id ?: string,
    u_usan_collaborator_1_first_name ?: string,
    u_usan_collaborator_1_last_name ?: string,
    u_usan_collaborator_1_email ?: string,
    u_usan_collaborator_2_sso_id ?: string,
    u_usan_collaborator_2_first_name ?: string,
    u_usan_collaborator_2_last_name ?: string,
    u_usan_collaborator_2_email ?: string,
    caseSysId ?: string,
    u_negotiator ?: string,
    u_case_status ?: string,
    u_file_number_single_entity ?: string,
    u_file_number_modified ?: string,

    u_suggested_names_in_order_of_preference_for_single_entity ?: string,
    u_name_for_which_you_are_requesting_a_revision ?: string,
    u_reason_for_revision ?: string,
    u_designation_for_salt_form ?: string,
    u_chemical_names_or_description ?: string,
    u_chemical_names_or_description_for_single_entity ?: string,
    u_chemical_names_or_description_for_salt_form ?: string,
    u_systematic_names_or_description ?: string,
    u_molecular_formula ?: string,
    u_molecular_formula_for_single_entity ?: string,
    u_molecular_formula_for_salt_form ?: string,
    u_molecular_weight ?: string,
    u_molecular_weight_for_single_entity ?: string,
    u_molecular_weight_for_salt_form ?: string,
    u_is_this_a_pro_drug ?: string,
    u_chemical_abstracts_service_cas_registry_number ?: string,
    u_chemical_abstracts_service_cas_registry_number_for_single_entity ?: string,
    u_chemical_abstracts_service_cas_registry_number_for_salt_form ?: string,
    u_indications_therapeutic_claim ?: string,
    u_unique_ingredient_identifier_unii_number ?: string,
    u_unique_ingredient_identifier_unii_number_salt ?: string,
    u_code_designations ?: string,
    u_code_designation_for_single_entity ?: string,
    u_code_designation_for_salt_form ?: string,
    u_trademarks ?: string,
    u_trivial_names ?: string,
    u_manufacturers ?: string,
    u_principal_theraputic_uses ?: string,
    u_pharmacologic_action ?: string,
    u_does_the_substance_bind_to_a_receptor_enzyme_or_other_target ?: string,
    u_substance_bind_explanation ?: string,
    u_inn_submission ?: string,
    u_inn_submission_explanation ?: string,
    u_phase_1_clinical_trials_began_date ?: string,
    u_please_disclose_if_there_is_a_polymer_present ?: string,
    u_please_disclose_whether_a_semi_interpenetrating_network_is_formed ?: string,
    u_please_disclose_the_degreee_of_polymerization ?: string,
    u_list_the_formula_for_each_monomer_and_for_the_whole_polymer ?: string,
    u_chemicals_attached ?: string,
    u_manufacturing_process ?: string,
    u_purity_of_2_hydroxyethyl_methacrylate_if_applicable ?: string,
    u_water_content ?: string,
    u_water_content_at_ambient_temperature_23_2_c ?: string,
    u_mean_value_standard_deviation_water_content ?: string,
    u_number_of_measurements_water_content ?: string,
    u_oxygen_permeability ?: string,
    u_oxygen_permeability_at_35_c ?: string,
    u_mean_value_standard_deviation_oxygen ?: string,
    u_number_of_measurements_oxygen ?: string,
    u_method_used_to_determine_oxygen_permeability ?: string,
    u_ind_application_numbers ?: string,
}

export const ApplicationDataToJson  = {
    'firstSuggestedName' : 'u_suggested_names_in_order_of_preference_for_single_entity',
    'revisionName' : 'u_name_for_which_you_are_requesting_a_revision',
    'revisionReason' : 'u_reason_for_revision',
    'designationForSalt' : 'u_designation_for_salt_form',
    'chemName' : 'u_chemical_names_or_description',
    'chemNameForEntity' : 'u_chemical_names_or_description_for_single_entity',
    'chemNameForSalt' : 'u_chemical_names_or_description_for_salt_form',
    'systematicName' : 'u_systematic_names_or_description',
    'molecularFormula' : 'u_molecular_formula',
    'molecularFormulaForEntity' : 'u_molecular_formula_for_single_entity',
    'molecularFormulaForSalt' : 'u_molecular_formula_for_salt_form',
    'molecularWeight' : 'u_molecular_weight',
    'molecularWeightForEntity' : 'u_molecular_weight_for_single_entity',
    'molecularWeightForSalt' : 'u_molecular_weight_for_salt_form',
    'isProdDrug' : 'u_is_this_a_pro_drug',
    'casRegistryNumber' : 'u_chemical_abstracts_service_cas_registry_number',
    'casRegistryForEntity' : 'u_chemical_abstracts_service_cas_registry_number_for_single_entity',
    'casRegistryForSalt' : 'u_chemical_abstracts_service_cas_registry_number_for_salt_form',
    'theraClaim' : 'u_indications_therapeutic_claim',
    'uniiNumber' : 'u_unique_ingredient_identifier_unii_number',
    'uniiNumberSalt' : 'u_unique_ingredient_identifier_unii_number_salt',
    'codeDesignation' : 'u_code_designations',
    'codeDesignationForEntity': 'u_code_designation_for_single_entity',
    'codeDesignationForSalt': 'u_code_designation_for_salt_form',
    'trademark': 'u_trademarks',
    'trivialName': 'u_trivial_names',
    'manufacturer': 'u_manufacturers',
    'principalTheraUse': 'u_principal_theraputic_uses',
    'pharmaAction': 'u_pharmacologic_action',
    'bindToReceptor': 'u_does_the_substance_bind_to_a_receptor_enzyme_or_other_target',
    'bindToReceptorExplanation': 'u_substance_bind_explanation',
    'innSubmission': 'u_inn_submission',
    'innSubmissionNumber': 'u_inn_submission_number',
    'innSubmissionExplanation': 'u_inn_submission_explanation',
    'clinicalTrialDate': 'u_phase_1_clinical_trials_began_date',
    'isPolymerPresent' : 'u_please_disclose_if_there_is_a_polymer_present',
    'semiInterNetwork' : 'u_please_disclose_whether_a_semi_interpenetrating_network_is_formed',
    'degreeOfPolymerization' : 'u_please_disclose_the_degreee_of_polymerization',
    'monomerFormula' : 'u_list_the_formula_for_each_monomer_and_for_the_whole_polymer',
    'chemicalsAttached' : 'u_chemicals_attached',
    'manufacturingProcess' : 'u_manufacturing_process',
    'purity' : 'u_purity_of_2_hydroxyethyl_methacrylate_if_applicable',
    'waterContent' : 'u_water_content',
    'waterContentAtAmbientTemp' : 'u_water_content_at_ambient_temperature_23_2_c',
    'waterContentMeanValue' : 'u_mean_value_standard_deviation_water_content',
    'waterContentMeasurement' : 'u_number_of_measurements_water_content',
    'oxygenPermeability' : 'u_oxygen_permeability',
    'oxygenPermeability35' : 'u_oxygen_permeability_at_35_c',
    'oxygenPermeabilityMeanValue' : 'u_mean_value_standard_deviation_oxygen',
    'oxygenPermeabilityMeasurement' : 'u_number_of_measurements_oxygen',
    'oxygenPermeabilityMethod' : 'u_method_used_to_determine_oxygen_permeability',
    'indApplNumber': 'u_ind_application_numbers',
    'street1': 'u_street_1',
    'street2': 'u_street_2',
    'city': 'u_city',
    'state': 'u_state',
    'zipCode': 'u_postal_code',
    'country': 'u_country',
    'phone': 'u_telephone_number',
    'phoneType': 'u_telephone_type',
    'contactPersonFirst': 'u_primary_contact_first_name',
    'contactPersonLast':'u_primary_contact_last_name',
    'pronoun':'u_pronoun',
    'title': 'u_title',
    'emailAddress':'u_email_address'
}

export interface AdminDashboardRequest {
    ssoId: string,
    status: string[]
}

export interface OrgData {
    name : string,
    orgId : string
}

export interface CreateOrgRequest {
    organizationName: string,
    addressLine1: string,
    addressLine2: string,
    city: string,
    state: string,
    zipCode: string,
    phoneNumber: number
}

export interface NegotiatorTableData {
    caseSysId: string,
    sys_id: string,
    fileNumber?: string,
    form: string,
    submittedDate: string,
    firstSuggestedName: string,
    contactName?: string,
    company?: string,
    contactEmail?: string,
    status: string
}

export interface NegotiatorResultData {
    name: string,
    sys_id: string,
    user_name: string,
	email: string
}

export interface ChangeStatusEmailRequest {
    applicantEmail: string,
    applicantName: string,
    status: string,
    fileNumber: string
}

export interface CheckForNegotiatorRequest {
    email: string,
    orgId: string
}

export interface NegotiatorDashboardRequest {
    email: string,
    status: string[]
}